<template>
    <div class="paper">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload Raisers Edge Actions File:</label>
                        <b-form ref="raisersedgeactions" style="margin-top:1rem;" @submit="ImportRaisersEdgeActions">
                            <b-form-group>
                                <b-form-file no-drop
                                             name="FileData"
                                             accept="*.csv"
                                             class="form-control"
                                             required />
                                <button class="form-control" type="submit">UPLOAD</button>
                            </b-form-group>
                        </b-form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload Welligent Bill Data:</label>
                        <b-form ref="uploadBills" style="margin-top:1rem;" @submit="ImportWelligentBills">
                            <b-form-group>
                                <b-form-file no-drop
                                             name="FileData"
                                             accept="*.csv"
                                             class="form-control"
                                             required />
                                <button class="form-control" type="submit">UPLOAD</button>
                            </b-form-group>
                            <div v-if="ImportWelligentBillsResult.TotalRecordsProcessed">
                                <p>Records Created: {{ ImportWelligentBillsResult.RecordsCreated }}</p>
                                <p>Records Deleted: {{ ImportWelligentBillsResult.RecordsDeleted }}</p>
                                <p>Records Updated: {{ ImportWelligentBillsResult.RecordsUpdated }}</p>
                                <p>Records Unchanged: {{ ImportWelligentBillsResult.RecordsUnchanged }}</p>
                                <p>Records Ignored: {{ ImportWelligentBillsResult.RecordsIgnored }}</p>
                                <p>TOTAL RECORDS PROCESSED: {{ ImportWelligentBillsResult.TotalRecordsProcessed }}</p>
                            </div>
                        </b-form>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Upload Welligent Note Data:</label>
                        <b-form ref="uploadNotes" style="margin-top:1rem;" @submit="ImportWelligentNotes">
                            <b-form-group>
                                <b-form-file no-drop
                                             name="FileData"
                                             accept="*.csv"
                                             class="form-control"
                                             required />
                                <button class="form-control" type="submit">UPLOAD</button>
                            </b-form-group>
                            <div v-if="ImportWelligentNotesResult.TotalRecordsProcessed">
                                <p>Records Created: {{ ImportWelligentNotesResult.RecordsCreated }}</p>
                                <p>Records Deleted: {{ ImportWelligentNotesResult.RecordsDeleted }}</p>
                                <p>Records Updated: {{ ImportWelligentNotesResult.RecordsUpdated }}</p>
                                <p>Records Unchanged: {{ ImportWelligentNotesResult.RecordsUnchanged }}</p>
                                <p>Records Ignored: {{ ImportWelligentNotesResult.RecordsIgnored }}</p>
                                <p>TOTAL RECORDS PROCESSED: {{ ImportWelligentNotesResult.TotalRecordsProcessed }}</p>
                            </div>
                        </b-form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    // import helper functions

    import { EventBus } from '../../services/event-bus.js';
    export default {
        data: function () {
            return {
                ImportWelligentNotesResult: {},
                ImportWelligentBillsResult: {},
               
            };
        },
        created() {
            
        },
        methods: {
            ImportWelligentNotes(e) {
                e.preventDefault();
                let form = this.$refs['uploadNotes'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("POST", "MentalHealth/Welligent/ImportNotesUpdateFile", formData, this.ImportWelligentNotesSuccess, () => { }, true);
            },
            ImportWelligentNotesSuccess(response) {
                this.ImportWelligentNotesResult = response.data.data;
            },
            ImportWelligentBills(e) {
                e.preventDefault();
                let form = this.$refs['uploadBills'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("POST", "MentalHealth/Welligent/ImportBillsUpdateFile", formData, this.ImportWelligentBillsSuccess, () => { }, true);
            },
            ImportWelligentBillsSuccess(response) {
                this.ImportWelligentBillsResult = response.data.data;
            },
            ImportRaisersEdgeActions(e) {
                e.preventDefault();
                let form = this.$refs['raisersedgeactions'];
                let formData = new FormData(form);
                this.$MasterAPI.ExecuteRequest("POST", "FundDevelopment/RaisersEdge/ReplaceActions", formData, this.ImportRaisersEdgeActionsSuccess, () => { }, true);
            },
            ImportRaisersEdgeActionsSuccess(response) {
                alert("file uploaded!");
            }
        },
        components: {
            
        },
        mounted() {
            
        },
        computed: {
            
        },
        watch: {
            
        },
    }
    
</script>

<style scoped>
    .paper{
        width: auto !important;
    }
</style>